 <template lang='pug'>
  v-container.pa-0(fluid wrap)
    // Dailogs
    v-dialog( :fullscreen="isMobile" width="400" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' :request='currentRequest' @close ='detailsDialog=false')
    // Content
    v-row.justify-center(class="pa-3")
      v-col(:cols="isMobile ? '4' : '2'")
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              p filtrar
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="loadLog('requests', $event.from,  $event.to)" currentType='requests',)
        .text-center(style="display:flex; align-items:center;")
      h2.d-flex.align-center(v-if="!isMobile") {{from === '' ? 'En los últimos 7 días ha realizado las siguientes pedidos: ' : 'Desde ' + from + ' hasta ' + to + ' ha realizado las siguientes pedidos: '}}
      v-col(sm='8' lg='3' v-if="isMobile")
        h5(class='ml-9') {{from === '' ? 'En los últimos 7 días ha realizado los siguientes pedidos: ' : 'Desde ' + from + ' hasta ' + to + ' ha realizado las siguientes pedidos: '}}
    v-layout(v-if="transactionNumber > 0" wrap='')
      v-flex(md12='').text-center.mt-2
        v-btn-toggle.main-filter__button-row.main-filter__button-row--right.mx-auto(shaped, borderless,)
          v-btn(@click="changeFilteredStatus('pending')" color="error" small).mx-1
            |Pendiente
            v-icon
          v-btn(@click="changeFilteredStatus('process')" color="warning" small).mx-1
            |Enviado
            v-icon
          v-btn(@click="changeFilteredStatus('completed')" color="green" small).mx-1
            |Completo
            v-icon
      v-flex(md12='' :style="isMobile ? 'width: 100%;' : 'max-width: 700px'").mx-auto.mt-3
        v-list(two-line="" v-if="transactions.length > 0")
            v-list-item-group
              template(v-for="(item, index) in transactions.slice(10*(page-1), 10*(page))")
                v-list-item(:key="item.reference_number" :class="getClass(item)").notification
                    template(v-slot:default="{ active, toggle }")
                        v-list-item-avatar(tile="" size="80")
                          v-img(:src='getImage(item)' contain)
                        v-list-item-content(@click="openDetail(item)")
                            p.font-weight-bold # {{item.reference_number}}
                            p.mt-2 {{item.location_from.name}}
                            p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                            span(:class="getColor(item)").mt-2 {{item.status | status}}
                            span.mt-2.font-weight-bold.notification__price ${{item.total}}
                        v-list-item-action
                          v-btn(@click="cancelRequest(item)" color="red" text='' :disabled="!(item.status != 'canceled' && item.status != 'completed')")
                            | CANCELAR
                    v-divider(v-if="index + 1 < transactions.length" :key="index")
              v-pagination.my-4(v-model="page" :length="pageNumber")
        template(v-else)
          NoResults(title="No tienes pedidos en esta categoria", description="Para ver todos tus pedidos deselecciona el botón")
    template(v-else)
      NoResults(title="Aún no tienes pedidos", description="En esta sección encontraras tus pedidos")
</template>

<script>
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import PurchaseForm from '@/components/custom/forms/PurchaseForm'
  import TransferForm from '@/components/custom/forms/TransferForm'
  import Preview from '@/components/custom/preview/ProductPreview'
  import BillPreview from '@/components/custom/preview/BillPreview'
  import loaders from '@/plugins/mixins/loaders'
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  export default {
    components: {
      BillPreview: BillPreview,
      Preview: Preview,
      PurchaseForm: PurchaseForm,
      TransferForm: TransferForm,
      DateFilter: DateFilter,
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      NoResults: () => import('@/components/custom/NoResults'),
      shopPlaceHolder: shopPlaceHolder,
    },
    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm')
      },
      status: function (status) {
        let responseStatus = ''
        switch (status) {
          case ('pending'):
            responseStatus = 'Pendiente'
            break
          case ('process'):
            responseStatus = 'Enviado'
            break
          case ('completed'):
            responseStatus = 'Completo'
            break
          case ('canceled'):
            responseStatus = 'Cancelado'
            break
        }
        return responseStatus
      },
    },
    mixins: [loaders],
    data () {
      return {
        transactionNumber: 0,
        filteredStatus: '',
        currentRequest: '',
        detailsDialog: false,
        from: '',
        to: '',
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        itemsState: [
          'pending',
          'cancel',
        ],
        page: 1,
        menu: false,
        currentLocation: null,
        select: {},
        currentTransaction: null,
        purchaseDialog: false,
        transferDialog: false,
        showBillDialog: false,
        search: '',
        currentType: '',
        createItemDialog: false,
        productDialog: false,
        headers: [
          {
            sortable: false,
            text: '# de referencia',
            value: 'type',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Productos',
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Fecha',
            value: 'time',
            align: 'left',

          },
          {
            sortable: false,
            text: 'Punto',
            value: 'location_from',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Total',
            value: 'total',
            align: 'left',

          },
          {
            text: '',
            value: 'data-table-expand',
          },
          {
            text: 'Estado',
            value: 'data-table-expand',
          },
          {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },
      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
        ]
      },
      requests () {
        const arrResponse = this.$store.state.transactions.requests
        if (arrResponse) {
          return arrResponse.reverse()
        }
        return arrResponse
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      // FILTRO DE TRANSACCIONES NO ESTA FUNCIONANDO CORRECTAMENTE, NO ACTUALIZA LOS DATOS DEPENDIENDO DE LA TIENDA
      transactions () {
        const vm = this
        let arrResponse = []
        if (!!vm.currentLocation && !!vm.requests) {
          // console.log('se escogio : ' + vm.currentLocation.name)
          arrResponse = vm.requests.filter((el) => {
            if (el.location_from.id === vm.currentLocation.id) {
              // console.log(el.location_from.id, vm.currentLocation.id)
              return true
            }
          })
        } else {
          // console.log('entra en nulo')
          arrResponse = vm.requests
        }
        if (arrResponse) {
          vm.transactionNumber = arrResponse.length
        }
        if (vm.filteredStatus !== '') {
          const filteredTransactions = arrResponse.filter(transaction => transaction.status === vm.filteredStatus)
          return filteredTransactions
        } else {
          return arrResponse
        }
      },
      pageNumber () {
        return Math.ceil(this.transactions.length / 10)
      },
    },
    watch: {
      transactions (val, oldval) {
        // console.log(val, oldval)
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'requests'
      },
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch(this.currentType)
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      getImage (item) {
        // console.log(item)
        if (item.location_from.pictures && item.location_from.pictures.imageInput1) {
          return item.location_from.pictures.imageInput1
        } else {
          return shopPlaceHolder
        }
      },
      getColor (item) {
        let status = ''
        switch (item.status) {
          case ('pending'):
            status = 'error--text'
            break
          case ('process'):
            status = 'warning--text'
            break
          case ('completed'):
            status = 'success--text'
            break
        }
        return status
      },
      getClass (item) {
        let status = ''
        switch (item.status) {
          case ('pending'):
            status = 'notification__pending'
            break
          case ('process'):
            status = 'notification__sent'
            break
          case ('completed'):
            status = 'notification__complete'
            break
        }
        return status
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
      cancelRequest (item) {
        // console.log(item)
        const idOrden = item.idOrden
        const uid = item.client.id
        const ban = false
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: 'canceled',
          idUser: uid,
        }
        this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
          // console.log(res)
          this.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
          this.currentType = this.$route.params.type
          this.fetch(this.currentType)
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      changeStatus (item, event) {
        // console.log(item)
        const idOrden = item.idOrden
        const uid = item.client.id
        const ban = false
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: event,
          idUser: uid,
        }
        if (item.status !== 'cancel') {
          this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
            // console.log(res)
            this.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
            this.currentType = this.$route.params.type
            this.fetch(this.currentType)
          })
        } else {
          this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
            // console.log(res)
            this.setDataNotification(true, 'red', 'No se puede actualizar el estado de la orden ya que ha sido cancelado.')
          })
        }
      },
      showBill (item) {
        this.currentTransaction = item
        // console.log(item)
        this.showBillDialog = !this.showBillDialog
      },
      showSupportImage (url) {
        this.$swal({
          title: 'Comprobante',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.menu = false
        vm.from = vm.formatDate(dateFrom)
        vm.to = vm.formatDate(dateTo)
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, true]).then(function () {

        })
      },
      fetch (type = 'requests') {
        // vm.$store.commit('setLoading',true);
        const dateFrom = this.$moment().format('YYYY-MM-DD')
        this.loadLog(type, dateFrom, this.$moment(dateFrom).add(1, 'days').format('YYYY-MM-DD'))
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },
      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },
      changeFilteredStatus (newStatus) {
        if (this.filteredStatus === '' || this.filteredStatus !== newStatus) {
          this.filteredStatus = newStatus
        } else {
          this.filteredStatus = ''
        }
      },
    },
  }
</script>

<style lang='scss' scoped>
.notification{
  display: flex;
  width: 95%;
  margin: 0 auto;
  // border-radius: 10px !important;
  box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
  &__container{
    @media (max-width: 1024px){
      background: transparent;
    }
  }
  &__pending{
    border-left: 4px solid #ff5252;
    font-weight: bold;
  }
  &__sent{
    border-left: 4px solid #fb8c00;
    font-weight: bold;
  }
  &__complete{
    border-left: 4px solid green;
    font-weight: bold;
  }
  &__date{
    font-size: 13px;
    color: #808184;
  }
  &__price{
    color: #35a3a9 !important;
  }
  &__description{
    color: #808184;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
